// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hC","advertCardPhoto__image":"c-a_hE"};